import { apiSlice } from '../../api/apiSlice';
import {
    SubAccountListParams,
    SubAccountListResponse,
} from './subAccountListApiSliceTypes';

const subAccountListApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getSubAccountList: builder.query<
            SubAccountListResponse,
            SubAccountListParams
        >({
            query: (params) => {
                const { page = 1, limit = 10, ...queryParams } = params ?? {};

                return {
                    url: '/sub-accounts',
                    method: 'GET',
                    headers: {
                        'Accept-Language': params.acceptLanguage ?? 'en',
                    },
                    params: {
                        page,
                        limit,
                        includeCurrent: true,
                        ...queryParams,
                    },
                };
            },
            providesTags: (result) =>
                result?.data?.items
                    ? [
                          ...result.data.items.map((subAccount) => ({
                              type: 'subAccounts' as const,
                              id: subAccount.id,
                          })),
                          { type: 'subAccounts', id: 'LIST' },
                      ]
                    : [{ type: 'subAccounts', id: 'LIST' }],
        }),
    }),
    overrideExisting: true,
});

export const { useGetSubAccountListQuery, useLazyGetSubAccountListQuery } =
    subAccountListApiSlice;
